<template>
    <div class="col-md-12">
        <div class="h2">Products, services, add-ons</div>
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <br/>
        <form @submit.prevent="updateProduct">
            <div class="p-4 mb-0 bg-white rounded-lg mb-4">
                <div class="h3">Products</div>
                <div class="float-right">
                            <span class="material-icons-outlined cursor-pointer text-primary"
                                  @click="isEditingProduct = !isEditingProduct" v-if="!isEditingProduct"
                                  title="edit">edit</span>

                    <button class="btn btn-primary mr-3"
                            v-else-if="isEditingProduct" @click="validation()">
                        Save
                    </button>

                    <span ref="cancelEditing" class="cursor-pointer" v-if="isEditingProduct" @click="isEditingProduct = false">
                        Cancel
                    </span>
                </div>
                <br/>
                <div class="pt-3">
                    <div class="table-responsive">
                        <table class="table table-bordered" aria-label="Products table">
                            <thead>
                            <tr>
                                <th class="border-right text-left">
                                    Name
                                </th>
                                <th class="border-right text-center">
                                    Description
                                </th>
                                <th class="border-right text-center">
                                    Type
                                </th>
                                <th class="border-right text-center">
                                    Price type
                                </th>
                                <th class="border-right text-center">
                                    Duration
                                </th>
                                <th v-if="isEditingProduct">

                                </th>
                            </tr>
                            </thead>
                            <tbody class="table-bordered">
                            <tr v-for="product in products">
                                <td class="text-center" style="width: 15%">
                                    <div>
                                        <div
                                            :class="{'d-flex align-items-left bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': product.name==='' && isSubmit}">
                                            <input type="text"
                                                   autocomplete="off"
                                                   class="form-control text-left border-0 py-0 shadow-none form-input"
                                                   v-model="product.name"
                                                   :disabled="!isEditingProduct"
                                                   :class="{view: !isEditingProduct}"
                                            >
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center" style="width: 15%">
                                    <div class="form-group">
                                        <br/>
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': product.description==='' && isSubmit}">
                                        <textarea
                                            class="form-control text-center border-0 py-0 shadow-none form-input"
                                            v-model="product.description"
                                            :disabled="!isEditingProduct"
                                            :class="{view: !isEditingProduct}"
                                        >
                                        </textarea>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center" style="width: 15%">
                                    <div v-if="!isEditingProduct">
                                        {{ product.type_readable }}
                                    </div>
                                    <div v-if="isEditingProduct">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': product.type==='' && isSubmit}">
                                            <select
                                                class="form-control text-center border-0 py-0 shadow-none form-input"
                                                v-model="product.type"
                                                :disabled="!isEditingProduct"
                                                :class="{view: !isEditingProduct}"
                                            >
                                                <option value="1">Product</option>
                                                <option value="2">Hourly product</option>
                                                <option value="3">Warehouse product</option>
                                            </select>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center" style="width: 15%">
                                    <div v-if="!isEditingProduct">
                                        {{ product.price_type_readable }}
                                    </div>
                                    <div v-if="isEditingProduct">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': product.price_type==='' && isSubmit}">
                                            <select class="form-control text-center border-0 py-0 shadow-none pr-5"
                                                    v-model="product.price_type"
                                                    :disabled="!isEditingProduct"
                                            >
                                                <option :value="priceType" v-for="(priceTypeName, priceType) in priceTypes">{{ priceTypeName }}</option>
                                            </select>
                                        </div>
                                    </div>

                                </td>
                                <td class="text-center" style="width: 15%">
                                    <div
                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProduct, 'border-danger': product.duration==='' && isSubmit}">
                                        <input type="text" min="0"
                                               autocomplete="off"
                                               class="form-control text-center border-0 py-0 shadow-none form-input"
                                               v-model="product.duration"
                                               :disabled="!isEditingProduct"
                                               :class="{view: !isEditingProduct}"
                                        >
                                    </div>
                                </td>
                                <td v-if="isEditingProduct" class="text-center" style="width: 10%">
                                    <div class="btn float-center btn-default btn-sm"
                                         @click="deleteProduct(product.id)">
                                        <div class="material-icons-outlined cursor-pointer text-primary"
                                             title="delete product">delete
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <a href="/products/create" class="btn btn-success d-inline-flex align-items-center"
                   @click="isEditingProduct = !isEditingProduct"
                   v-if="!isEditingProduct">
                    <span class="material-icons-outlined cursor-pointer text-white mr-2">add_circle_outline</span>
                    <span>Add product</span>
                </a>
            </div>
        </form>
        <br/>
        <br/>
        <form @submit.prevent="updateService">
            <div class="p-4 mb-0 bg-white rounded-lg" ref="services">
                <div class="h3">Services</div>
                <div class="">
                    <div class="">
                        <span class="container-services"></span>
                        <div class="float-right">

                             <span class="material-icons-outlined cursor-pointer text-primary"
                                   @click="scrollToService({behavior: 'smooth'},'container-services'); isEditingService = !isEditingService"
                                   v-if="!isEditingService"
                                   title="edit">edit</span>
                            <button class="btn btn-primary mr-3"
                                    v-else-if="isEditingService" @click="validationService()">
                                Save
                            </button>

                            <span ref="cancelEditing"
                                  class="cursor-pointer"
                                  v-if="isEditingService"
                                  @click="scrollToService({behavior: 'smooth'},'container-services');
                                        isEditingService = false">
                                        Cancel
                            </span>
                        </div>
                    </div>
                    <br/>
                    <div class="d-flex justify-content-between align-items-start table-responsive">
                        <div v-for="(typeName, type) in types" style="width: 49%;">
                            <div>
                                <h4>{{ typeName }}</h4>
                            </div>
                            <table class="table border" aria-label="Services table">
                                <thead>
                                <tr>
                                    <th class="border-right text-left">
                                        Name
                                    </th>
                                    <th class="border-right text-center">
                                        Duration
                                    </th>
                                    <th v-if="isEditingService"></th>
                                </tr>
                                </thead>
                                <draggable class="drag table-bordered" v-model="services" tag="tbody" @end="onEndDragService">
                                    <tr v-for="service in services" v-if="service.id!==12 && service.deleted_at===null && service.type == type">
                                        <td class="text-center" style="width: 15%">
                                            <div>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingService, 'border-danger': service.name=='' && isSubmitService}">
                                                    <input type="text"
                                                           autocomplete="off"
                                                           class="form-control  text-left border-0 py-0 shadow-none form-input"
                                                           v-model="service.name"
                                                           :disabled="!isEditingService"
                                                           :class="{view: !isEditingService}"
                                                    >
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="text-center" style="width: 15%">
                                            <div>
                                                <div
                                                    :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingService, 'border-danger': service.duration=='' && isSubmitService}">
                                                    <input type="number" min="0"
                                                           autocomplete="off"
                                                           class="form-control text-center border-0 py-0 shadow-none form-input"
                                                           v-model="service.duration"
                                                           :disabled="!isEditingService"
                                                           :class="{view: !isEditingService}"
                                                    >
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </td>
                                        <td v-if="isEditingService" class="text-center" style="width: 10%">
                                            <div class="btn float-center btn-default btn-sm"
                                                 @click="deleteService(service.id)">
                                                <div class="material-icons-outlined cursor-pointer text-primary"
                                                     title="delete product">delete
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </draggable>
                            </table>
                        </div>
                    </div>

                    <a href="/services/create" class="btn btn-success d-inline-flex align-items-center"
                       @click="isEditingService = !isEditingService"
                       v-if="!isEditingService">
                        <span class="material-icons-outlined cursor-pointer text-white mr-2">add_circle_outline</span>
                        <span>Add service</span>
                    </a>

                </div>
            </div>
        </form>
        <br/>
        <br/>
        <form @submit.prevent="updatePrices">
            <div class="p-4 mb-0 bg-white rounded-lg" ref="services">
                <div class="d-flex justify-content-between align-items-center">
                    <div class="h3">Intervals and prices</div>
                    <a class="btn float-left btn-success d-inline-flex align-items-center" @click="toggleModal">
                        <span class="material-icons-outlined cursor-pointer text-white mr-2" title="add interval">add_circle_outline</span>
                        <span>Add new interval</span>
                    </a>
                </div>

                <div class="">
                    <div class="">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                    <select class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="intervals.price_type"
                                            @change="onChangePriceType($event)">
                                        <option value="1">Standard price</option>
                                        <option value="2">Minimum price</option>
                                        <option value="3">Cost price</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <br/>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="h4 mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <strong class="white-space-nowrap">Intervals</strong>
                                    </div>
                                </div>
                                <table class="table border" aria-label="Dimensions table">
                                    <thead>
                                    <tr>
                                        <th>
                                        </th>
                                        <th class="text-center" v-for="dimension in dimensions">
                                            <div v-if="dimension.id!==removeIntervalValue">
                                                <div
                                                    class="btn float-center btn-sm"
                                                    @click="removeIntervalColumn(dimension.id)">
                                                    <div class="material-icons-outlined text-danger cursor-pointer"
                                                         title="delete interval">remove_circle
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="dimension.id===removeIntervalValue">
                                                <a href="#" @click="cancelRemoveIntervalColumn">
                                                    cancel deleting
                                                </a>
                                            </div>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody class="table-bordered">
                                    <tr>
                                        <td style="width: 20%">
                                            Max volume
                                        </td>
                                        <td class="text-center" style="width: 10%" v-for="dimension in dimensions">
                                            <div v-if="dimension.id!==removeIntervalValue">
                                                {{ dimension.max_volume|number }}cbm
                                            </div>
                                            <div v-if="dimension.id===removeIntervalValue">
                                                <span class="material-icons-outlined text-danger  cursor-pointer">remove_circle</span>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Max weight
                                        </td>
                                        <td class="text-center" v-for="dimension in dimensions">
                                            <div v-if="dimension.id!==removeIntervalValue">
                                                {{ dimension.max_weight|number }}kg
                                            </div>
                                            <div v-if="dimension.id===removeIntervalValue">
                                                <div
                                                    class="material-icons-outlined text-danger  cursor-pointer">
                                                    remove_circle
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <br/>
                                <div class="h4 mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <strong class="white-space-nowrap">Products (ground price) </strong>
                                        <div v-if="removeInterval===false">
                                            <span class="product-price"></span>

                                            <span class="material-icons-outlined text-primary cursor-pointer"
                                                  @click="scrollToService({behavior: 'smooth'},'product-price');
                                                       isEditingProductPrice = !isEditingProductPrice"
                                                  v-if="!isEditingProductPrice"
                                                  title="edit">edit
                                            </span>

                                            <span ref="cancelEditing"
                                                  v-if="isEditingProductPrice"
                                                  @click="scrollToService({behavior: 'smooth'},'product-price');
                                                        isEditingProductPrice = false">
                                                        Cancel
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <table class="table border" aria-label="Products ground price table">
                                    <tbody class="table-bordered">
                                    <tr v-for="product in products">
                                        <td style="width:20%">
                                            {{ product.name }}
                                        </td>
                                        <td class="text-center" style="width:10%"
                                            v-for="(item, index) of product.prices">
                                            <div v-if="priceType==='2'">
                                                <div class="form-group">
                                                    <div
                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProductPrice}">
                                                        <input type="text"
                                                               autocomplete="off"
                                                               class="form-control text-center  border-0 py-0 shadow-none form-input"
                                                               v-model="item.minimum_price"
                                                               v-number
                                                               :disabled="!isEditingProductPrice"
                                                               :class="{view: !isEditingProductPrice}"
                                                               @input="handlePrice($event.target.value, item.interval_id, item.product_id, 'product')"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else-if="priceType==='3'">
                                                <div class="form-group">
                                                    <div
                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProductPrice}">
                                                        <input type="text"
                                                               autocomplete="off"
                                                               class="form-control text-center border-0 py-0 shadow-none form-input"
                                                               v-model="item.cost_price"
                                                               v-number
                                                               :disabled="!isEditingProductPrice"
                                                               :class="{view: !isEditingProductPrice}"
                                                               @input="handlePrice($event.target.value, item.interval_id, item.product_id, 'product')"

                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="form-group">
                                                    <div
                                                        :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingProductPrice}">
                                                        <input type="text"
                                                               class="form-control text-center border-0 py-0 shadow-none form-input"
                                                               autocomplete="off"
                                                               v-model="item.standard_price"
                                                               v-number
                                                               :disabled="!isEditingProductPrice"
                                                               :class="{view: !isEditingProductPrice}"
                                                               @input="handlePrice($event.target.value, item.interval_id, item.product_id, 'product')"
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                                <br/>
                                <div class="h4 mb-3">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <strong class="white-space-nowrap">Services (add-on fee) </strong>
                                        <span class="service-price"></span>
                                        <div v-if="removeInterval===false">
                                            <span class="material-icons-outlined text-primary cursor-pointer"
                                                  @click="scrollToService({behavior: 'smooth'},'service-price'); isEditingServicePrice = !isEditingServicePrice"
                                                  v-if="!isEditingServicePrice"
                                                  title="edit">edit
                                            </span>

                                            <span
                                                ref="cancelEditing"
                                                v-if="isEditingServicePrice"
                                                @click="scrollToService({behavior: 'smooth'},'service-price');
                                                    isEditingServicePrice = false">
                                                    Cancel
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div v-for="(typeName, type) in types" class="mt-5">
                                    <h4>{{ typeName }}</h4>
                                    <table class="table border" :aria-label="`Sevices add-on-fee ${typeName} table`">
                                        <tbody class="table-bordered">
                                        <tr v-for="product in services" v-if="product.deleted_at===null && product.type == type">
                                            <td style="width: 20%">
                                                {{ product.name }}
                                            </td>
                                            <td style="width: 10%" v-for="(item, index) of product.prices">
                                                <div v-if="priceType==='2'">
                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingServicePrice}">
                                                            <input type="text"
                                                                   class="form-control  text-center border-0 py-0 shadow-none form-input"
                                                                   autocomplete="off"
                                                                   v-model="item.minimum_price"
                                                                   v-number
                                                                   :disabled="!isEditingServicePrice"
                                                                   :class="{view: !isEditingServicePrice}"
                                                                   @input="handlePrice($event.target.value, item.interval_id, item.service_id, 'service')"
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else-if="priceType==='3'">
                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingServicePrice}">
                                                            <input type="text"
                                                                   class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                   autocomplete="off"
                                                                   v-model="item.cost_price"
                                                                   v-number
                                                                   :disabled="!isEditingServicePrice"
                                                                   :class="{view: !isEditingServicePrice}"
                                                                   @input="handlePrice($event.target.value, item.interval_id, item.service_id, 'service')"
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-else>
                                                    <div class="form-group">
                                                        <div
                                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingServicePrice}">
                                                            <input type="text"
                                                                   class="form-control text-center  border-0 py-0 shadow-none form-input"
                                                                   v-model="item.standard_addon_price"
                                                                   v-number
                                                                   :disabled="!isEditingServicePrice"
                                                                   :class="{view: !isEditingServicePrice}"
                                                                   @input="handlePrice($event.target.value, item.interval_id, item.service_id, 'service')"
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <br/>
                    </div>
                </div>
                <br/>

                <div class="row">
                    <div class="col-md-4">
                        <button class="btn float-left btn-success btn-lg">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </form>

        <br/>
        <form @submit.prevent="updateAddOns">
            <div class="p-4 mb-0 bg-white rounded-lg" ref="add-ons">
                <div class="h3">Add-ons</div>
                <div class="">
                    <div class="">
                        <span class="container-add-ons"></span>
                        <div class="float-right">
                             <span class="material-icons-outlined cursor-pointer text-primary"
                                   @click="scrollToService({behavior: 'smooth'},'container-add-ons'); isEditingAddOn = !isEditingAddOn"
                                   v-if="!isEditingAddOn"
                                   title="edit">edit</span>
                            <button class="btn btn-primary mr-3"
                                    v-else-if="isEditingAddOn" @click="validationAddOn">
                                Save
                            </button>
                            <span ref="cancelEditing"
                                  class="cursor-pointer"
                                  v-if="isEditingAddOn"
                                  @click="scrollToService({behavior: 'smooth'},'container-add-ons');
                                        isEditingAddOn = false">
                                        Cancel
                            </span>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <table class="table border" aria-label="Add-ons table">
                        <thead>
                        <tr>
                            <th class="border-right">
                                Name
                            </th>
                            <th class="border-right">
                                Description
                            </th>
                            <th class="border-right">
                                Type
                            </th>
                            <th class="border-right">
                                Default values
                            </th>
                            <th class="border-right">
                                Send to Optimoroute
                            </th>
                            <th v-if="isEditingAddOn"></th>
                        </tr>
                        </thead>
                        <draggable class="drag table-bordered" v-model="addOns" tag="tbody" @end="onEndDragAddOn">
                            <tr v-for="(addOn, index) in addOns">
                                <td class="" style="width: 25%">
                                    <div>
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddOn && !staticAddOns.includes(addOn.key), 'border-danger': addOn.name=='' && isSubmitAddOn}">
                                            <input type="text"
                                                   required
                                                   autocomplete="off"
                                                   class="form-control  text-left border-0 py-0 shadow-none form-input"
                                                   v-model="addOn.name"
                                                   :disabled="!isEditingAddOn || staticAddOns.includes(addOn.key)"
                                            >
                                        </div>
                                        <div class="text-danger" v-if="addOnErrors[`${index}.name`]">
                                            {{ addOnErrors[`${index}.name`] }}
                                        </div>
                                    </div>
                                </td>
                                <td class="" style="width: 25%">
                                    <br/>
                                    <div class="form-group">
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddOn, 'border-danger': addOn.description=='' && isSubmitAddOn}">
                                                <textarea
                                                    class="form-control border-0 py-0 shadow-none form-input"
                                                    v-model="addOn.description"
                                                    :disabled="!isEditingAddOn"
                                                >
                                                </textarea>
                                        </div>
                                        <div class="text-danger" v-if="addOnErrors[`${index}.description`]">
                                            {{ addOnErrors[`${index}.description`] }}
                                        </div>
                                    </div>
                                </td>
                                <td style="width: 10%;">
                                    <div v-if="!isEditingAddOn">
                                        {{ types[addOn.type] }}
                                    </div>
                                    <div v-else>
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingAddOn, 'border-danger': addOn.type=='' && isSubmitAddOn}">
                                            <select class="form-control text-center border-0 py-0 shadow-none pr-5"
                                                    v-model="addOn.type"
                                                    :disabled="!isEditingAddOn"
                                                    :class="{view: !isEditingAddOn}"
                                            >
                                                <option :value="i" v-for="(type, i) in types">{{ type }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </td>
                                <td style="width: 30%">
                                    <div v-if="addOn.key === addOnFutureDays ">
                                        <div class="flex-grow-1">
                                            <div class="d-flex align-items-center justify-content-center mb-1">
                                                <span class="mr-3" style="width: 150px;">Default</span>
                                                <input
                                                    class="form-control small-input mr-3"
                                                    type="number"
                                                    step="1"
                                                    v-if="isEditingAddOn"
                                                    v-model="addOn.default_configurations['future_days']"
                                                >
                                                <span v-else class="flex-grow-1">{{ addOn.default_configurations['future_days'] }}</span>
                                                <span style="width: 80px;">Days</span>
                                            </div>
                                            <div class="d-flex align-items-center justify-content-center mb-2">
                                                <span class="mr-3" style="width: 150px;">Want more?</span>
                                                <input
                                                    class="form-control small-input mr-3"
                                                    type="number"
                                                    step="1"
                                                    v-if="isEditingAddOn"
                                                    v-model="addOn.default_configurations['want_more']"
                                                >
                                                <span v-else class="flex-grow-1">{{ addOn.default_configurations['want_more'] }}</span>
                                                <span style="width: 80px;">Weeks</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-else-if="addOn.default_configurations['redirect']">
                                        <span v-html="addOn.default_configurations['redirect']"></span>
                                    </div>

                                    <div v-else>
                                        <div class="d-flex align-items-center">
                                            <div class="address-type-label bold-font mr-5" style="min-width: 50px;">
                                                <strong>Price</strong>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <input
                                                    class="form-control small-input"
                                                    type="number"
                                                    step="0.01"
                                                    v-if="isEditingAddOn"
                                                    v-model="addOn.default_configurations['price']"
                                                >
                                                <span v-else>{{ addOn.default_configurations['price'] }}</span>
                                                <span class="ml-2">kr.</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="isEditingAddOn">
                                        <label class="newInput mb-0">
                                            <input type="checkbox"
                                                   v-model="addOn.send_to_optimo"
                                            >
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                    <div v-else>
                                        {{ addOn.send_to_optimo ? 'Yes' : 'No' }}
                                    </div>
                                </td>
                                <td v-if="isEditingAddOn" class="text-center" style="width: 10%">
                                    <div class="btn float-center btn-default btn-sm"
                                         v-if="!staticAddOns.includes(addOn.key)"
                                         @click="deleteAddOn(addOn.id)">
                                        <div class="material-icons-outlined cursor-pointer text-primary"
                                             title="delete product">delete
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </draggable>
                    </table>
                    <br/>

                    <a href="/add-ons/create" class="btn btn-success d-inline-flex align-items-center"
                       v-if="!isEditingAddOn">
                        <span class="material-icons-outlined cursor-pointer text-white mr-2">add_circle_outline</span>
                        <span>Create add-on</span>
                    </a>

                </div>
            </div>
        </form>
        <br/>

        <br/>
        <form @submit.prevent="updateCustomServices">
            <div class="p-4 mb-0 bg-white rounded-lg" ref="custom-services">
                <div class="h3">Custom services</div>
                <div class="">
                    <div class="">
                        <span class="container-custom-services"></span>
                        <div class="float-right">
                             <span class="material-icons-outlined cursor-pointer text-primary"
                                   @click="scrollToService({behavior: 'smooth'},'container-custom-services'); isEditingCustomService = !isEditingCustomService"
                                   v-if="!isEditingCustomService"
                                   title="edit">edit</span>
                            <button class="btn btn-primary mr-3"
                                    v-else-if="isEditingCustomService" @click="validationCustomService">
                                Save
                            </button>
                            <span ref="cancelEditing"
                                  class="cursor-pointer"
                                  v-if="isEditingCustomService"
                                  @click="scrollToService({behavior: 'smooth'},'container-custom-services');
                                        isEditingCustomService = false">
                                        Cancel
                            </span>
                        </div>
                    </div>
                    <br/>
                    <br/>
                    <table class="table border" aria-label="Add-ons table">
                        <thead>
                        <tr>
                            <th class="border-right">
                                Name
                            </th>
                            <th v-if="isEditingCustomService"></th>
                        </tr>
                        </thead>
                        <draggable class="drag table-bordered" v-model="customServices" tag="tbody" @end="onEndDragCustomService">
                            <tr v-for="(customService, index) in customServices">
                                <td class="" style="width: 80%">
                                    <div>
                                        <div
                                            :class="{'d-flex align-items-center bg-white border rounded-lg div-focus border-2':isEditingCustomService, 'border-danger': customService.name=='' && isSubmitCustomService}">
                                            <input type="text"
                                                   required
                                                   autocomplete="off"
                                                   class="form-control  text-left border-0 py-0 shadow-none form-input"
                                                   v-model="customService.name"
                                                   :disabled="!isEditingCustomService"
                                                   :class="{view: !isEditingCustomService}"
                                            >
                                        </div>
                                        <div class="text-danger" v-if="customServiceErrors[`${index}.name`]">
                                            {{ customServiceErrors[`${index}.name`] }}
                                        </div>
                                    </div>
                                </td>
                                <td v-if="isEditingCustomService" class="text-center" style="width: 20%">
                                    <div class="btn float-center btn-default btn-sm"
                                         @click="deleteCustomService(customService.id)">
                                        <div class="material-icons-outlined cursor-pointer text-primary"
                                             title="delete custom service">delete
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </draggable>
                    </table>
                    <br/>

                    <a href="/custom-services/create" class="btn btn-success d-inline-flex align-items-center"
                       v-if="!isEditingCustomService">
                        <span class="material-icons-outlined cursor-pointer text-white mr-2">add_circle_outline</span>
                        <span>Create custom service</span>
                    </a>

                </div>
            </div>
        </form>
        <br/>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create new interval</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="addNewInterval">
                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDimensions.max_volume=='' && isSubmitNew? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none form-input"
                                           placeholder="Max volume"
                                           v-model="newDimensions.max_volume"
                                    >
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                     :class="newDimensions.weight=='' && isSubmitNew? 'border-danger':''">
                                    <input type="text"
                                           required
                                           autocomplete="off"
                                           class="form-control  border-0 py-0 shadow-none form-input"
                                           placeholder="Max weight"
                                           v-model="newDimensions.max_weight"
                                    >
                                </div>
                            </div>

                            <button class="btn btn-primary" @click="validationNew()">
                                Save
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div
            ref="recurringModal"
            class="modal fade"
            :class="{show, 'd-block': activeRecurringModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">This product is on recurring</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModalRecurring"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-for="recurring in recurrings">{{ recurring.name }} ({{ recurring.id }})</div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" @click="deleteProduct(deleteProductId, 1)">
                            Delete product anyway
                        </button>
                        <button class="btn btn-secondary" @click="toggleModalRecurring">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval || activeRecurringModalInterval" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
    name: "ProductDataTable",
    components: {draggable},
    props: {
        priceTypes: {type: Object, required: true},
        staticAddOns: {type: Array, required: true},
        addOnFutureDays: {type: Number, required: true},
        typePickup: {type: Number, required: true},
        typeDropoff: {type: Number, required: true},
        types: {type: Object, required: true},
    },
    data() {
        return {
            items: [],
            products: {},
            services: [],
            activeModalInterval: false,
            activeRecurringModalInterval: false,
            show: false,
            isEditingProduct: false,
            isEditingService: false,
            isEditingAddOn: false,
            isEditingCustomService: false,
            isEditingProductPrice: false,
            isEditingServicePrice: false,
            intervals: {'price_type': 1},
            removeInterval: false,
            removeIntervalValue: '',
            priceType: 1,
            productPrices: [{price: '', price_type: '', interval_id: '', entity_type: '', entity_id: '' }],
            price: {},
            newDimensions: {},
            dimensions: {},
            isSubmit: false,
            isSubmitService: false,
            isSubmitAddOn: false,
            isSubmitCustomService: false,
            recurrings: [],
            deleteProductId: '',
            addOns: [],
            addOnErrors: {},
            customServices: [],
            customServiceErrors: {},
        }
    },
    methods: {
        onEndDragService() {
            if (!this.isEditingService) {
                this.update('services', false);
            }
        },
        onEndDragAddOn() {
            if (!this.isEditingAddOn) {
                this.updateAddOns(false);
            }
        },
        onEndDragCustomService() {
            if (!this.isEditingCustomService) {
                this.updateCustomServices(false);
            }
        },
        fetchData() {
            axios.get('/product-list/0')
                .then(({data}) => {
                    this.products = data.data;
                }).catch(error => this.products = []);
            axios.get('/service-list/0')
                .then(({data}) => {
                    this.services = Object.values(data.data);
                }).catch(error => this.services = []);
            axios.get('/intervals-list/0')
                .then(({data}) => {
                    this.dimensions = data.data;
                }).catch(error => this.dimensions = []);
            axios.get('/add-ons-list')
                .then(({data}) => {
                    this.addOns = data.data;
                }).catch(error => this.addOns = []);
            axios.get('/custom-services-list')
                .then(({data}) => {
                    this.customServices = data.data;
                }).catch(error => this.customServices = []);
        },
        validationNew() {
            this.isSubmitNew = true;
        },
        validation() {
            this.isSubmit = true;
        },
        validationService() {
            this.isSubmitService = true;
        },
        validationAddOn() {
            this.isSubmitAddOn = true;
        },
        validationCustomService() {
            this.isSubmitCustomService = true;
        },
        handlePrice(value, interval_id, entity_id, entity_type) {
            this.productPrices.push({
                price: value,
                price_type: this.priceType,
                interval_id: interval_id,
                entity_id: entity_id,
                entity_type: entity_type,
            });
        },
        updateProduct() {
            this.update('products');
        },
        updateService() {
            this.update('services');
        },
        updateAddOns(reload = true) {
            this.addOnErrors = {};
            axios.patch(`/add-ons`, this.addOns).then((response) => {
                if (reload) {
                    this.$refs.cancelEditing.click();
                    window.location.href = `/products`;
                }
            }).catch(err => {
                this.flashMessage.error({
                    title: '',
                    message: err.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(err.response.data);

                if (err.response.data.errors) {
                    for (let i in err.response.data.errors) {
                        this.$set(this.addOnErrors, i, err.response.data.errors[i][0]);
                    }
                }
            });
        },
        updateCustomServices(reload = true) {
            this.customServiceErrors = {};
            axios.patch(`/custom-services`, this.customServices).then((response) => {
                if (reload) {
                    this.$refs.cancelEditing.click();
                    window.location.href = `/products`;
                }
            }).catch(err => {
                this.flashMessage.error({
                    title: '',
                    message: err.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(err.response.data);

                if (err.response.data.errors) {
                    for (let i in err.response.data.errors) {
                        this.$set(this.customServiceErrors, i, err.response.data.errors[i][0]);
                    }
                }
            });
        },
        update(entity, reload = true) {
            axios.patch(`/${entity}`, this[entity]).then((response) => {
                if (reload) {
                    this.$refs.cancelEditing.click();
                    window.location.href = `/products`;
                }
            }).catch(err => {
                this.flashMessage.error({
                    title: '',
                    message: err.response.data.message,
                    time: 2000,
                    blockClass: 'flash-message error'
                });
                console.log(err.response.data);
            });
        },
        updatePrices() {
            if (this.removeIntervalValue > 0) {
                axios.delete(`/interval/${this.removeIntervalValue}/0`).then((response) => {
                    window.location.href = `/products`;
                }).catch(err => console.log(err))
            } else {
                axios.patch(`/save-prices`, this.productPrices).then((response) => {
                    window.location.reload();
                }).catch(err => console.log(err))
            }
        },
        addNewInterval: function () {
            axios.post(`/new-interval/0`, this.newDimensions).then((response) => {
                if (response.data.result === 'error') {
                    alert(response.data.message);
                } else {
                    window.location.href = `/products`;
                }
            }).catch(err => console.log(err))
        },
        removeIntervalColumn: function (value) {
            this.removeInterval = true;
            this.removeIntervalValue = value;
        },
        cancelRemoveIntervalColumn: function (value) {
            this.removeInterval = false;
            this.removeIntervalValue = '';
        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        toggleModalRecurring() {
            const body = document.querySelector("body");
            this.activeRecurringModalInterval = !this.activeRecurringModalInterval;
            this.activeRecurringModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        onChangePriceType(event) {
            this.priceType = event.target.value;
        },
        deleteProduct(value, forceDelete = 0) {
            this.deleteProductId = value;
            axios.delete(`/products/${value}`, {params: {forceDelete: forceDelete}}).then((response) => {
                if (response.data.recurringsHasTheProduct) {
                    this.recurrings = response.data.recurrings;
                    this.toggleModalRecurring();

                } else if(response.data.needConfirmation) {
                    if (confirm('Are you sure you want to delete the product?')) {
                        this.deleteProduct(value, 1);
                    }

                } else {
                    window.location.href = `/products`;
                }
            }).catch(err => console.log(err))
        },
        deleteService(value) {
            if (confirm('Are you sure you want to delete the service?')) {
                axios.delete(`/services/${value}`).then((response) => {
                    window.location.href = `/products`;
                }).catch(err => {
                    this.flashMessage.error({
                        title: '',
                        message: err.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(err.response.data);
                });
            }
        },
        deleteAddOn(value) {
            if (confirm('Are you sure you want to delete the add-on?')) {
                axios.delete(`/add-ons/${value}`).then((response) => {
                    window.location.href = `/products`;
                }).catch(err => {
                    this.flashMessage.error({
                        title: '',
                        message: err.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(err.response.data);
                });
            }
        },
        deleteCustomService(value) {
            if (confirm('Are you sure you want to delete the custom service?')) {
                axios.delete(`/custom-services/${value}`).then((response) => {
                    window.location.href = `/products`;
                }).catch(err => {
                    this.flashMessage.error({
                        title: '',
                        message: err.response.data.message,
                        time: 2000,
                        blockClass: 'flash-message error'
                    });
                    console.log(err.response.data);
                });
            }
        },
        scrollToService(options, elementToScroll) {
            const el = this.$el.getElementsByClassName(elementToScroll)[0];
            if (el) {
                el.scrollIntoView(options);
            }
        },
    },
    created() {
        return this.fetchData()
    },
    filters: {
        number: function (value) {
            return value.toLocaleString('da-DK');
        }
    },
}

</script>

<style scoped>

.view {
    border-color: transparent;
    background-color: initial;
    color: initial
}

.form-control:disabled, .form-control[readonly] {
    background-color: #ffffff;
    /*f8fafc*/
    opacity: 1;
}

select[disabled] {
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';

}

textarea[disabled] {
    resize: none;
}

.borderless {
    border: none;
}

select.form-control {
    font-size: 14px !important;
}

.checkmark {
    top: -10px;
    left: 35%;
}

</style>

